import { telemetryOptions, telemetryUser } from "~/lib/telemetry";

// Grafana Faro (errors, web vitals, fetch spans with traceparent to the master API) through the
// same-origin /collect proxy. Off unless NUXT_PUBLIC_TELEMETRY_ENABLED=true (see chart faro.*).
export default defineNuxtPlugin({
    name: "telemetry",
    setup(nuxtApp) {
        const options = telemetryOptions(useRuntimeConfig().public);

        if (!options) {
            return;
        }

        const router = useRouter();

        const start = async () => {
            try {
                const [{ createTelemetry }, { attachVue }] = await Promise.all([
                    import("@smakecloud/browser-telemetry"),
                    import("@smakecloud/browser-telemetry/vue"),
                ]);
                const faro = await createTelemetry(options);

                if (!faro) {
                    return;
                }

                attachVue(nuxtApp, router, faro);

                // The token store needs the vue-query client, so it is created in the app context.
                // Ids only; again after /entrance and on logout.
                nuxtApp.runWithContext(() => {
                    const tokenStore = useTokenStore();

                    watch(
                        () => telemetryUser(tokenStore.payload),
                        (user) => {
                            if (user) {
                                faro.api.setUser(user);
                            } else {
                                faro.api.resetUser();
                            }
                        },
                        { immediate: true },
                    );
                });
            } catch (error) {
                console.warn("telemetry: not started", error);
            }
        };

        // not awaited: the app does not wait for the Faro chunk
        void start();
    },
});
